export const EMAIL_APPOINTMENT_SUBJECT_PREFIXES_REG_EXP =
  /^(?:\s*(?:re|fwd?|aw|wg)\s*:)+/i
